module.exports = __webpack_public_path__ + "static/media/krx-public-05.91d87a63.jpg";